import { attributesCalloutSchema } from "./attributes.js";
import { validate } from "../../helpers/validate.js";
import { guideCalloutHtml } from "../../elements/callout/component.js";
import { CalloutType } from "./attributes.js";
import { ScalarCalloutVue, calloutIconNameFromType } from "./component.js";
const scalarCallout = {
  name: "scalar-callout",
  tagName: "scalar-callout",
  tiptapName: "callout",
  attributeTransform: (_, attrs) => {
    return validate(attributesCalloutSchema, {
      ...attrs,
      icon: typeof attrs.icon === "string" ? attrs.icon : typeof attrs.icon?.src === "string" ? attrs.icon?.src : "",
      // Handle legacy `calloutType` attribute
      type: attrs.type || attrs.calloutType || "neutral"
    });
  },
  render: async (props) => {
    const transformed = scalarCallout.attributeTransform("", props);
    return transformed ? guideCalloutHtml(transformed) : "";
  }
};
export {
  CalloutType,
  ScalarCalloutVue,
  calloutIconNameFromType,
  scalarCallout
};
//# sourceMappingURL=index.js.map
